<button
  class="grid grid-flow-col gap-1 items-center justify-start px-3 py-1 rounded-[4px] box-border border-[1px]"
  [ngClass]="{
    'border-neutrals-300 bg-neutrals-0': !recurring,
    'border-[#F1AD00] bg-[#FFF8E5]': recurring,
  }"
>
  <ui-icon
    *ngIf="recurring; else noStar"
    view-box="0 0 20 20"
    name="level-star-on"
    m-size="20"
    size="20"
  />
  <ng-template #noStar>
    <ui-icon view-box="0 0 20 20" name="level-star-off" m-size="20" size="20" />
  </ng-template>

  <ui-paragraph type="p12" mobile-type="p12" text-color="neutrals-900">
    Cliente Recurrente
  </ui-paragraph>
</button>
